// Re-use for Component's without a Layout
export default function EmptyLayout({children}: {children: React.ReactNode}) {
  return <>{children}</>
}
